import { usePage, useForm } from '@inertiajs/react'

import { Button } from "@/components/ui/button"
import { PageHeader } from "@/components/core/page_header"

import styleGuideApi from "@/api/Organizations/StyleGuideApi"

import Layout from '@/pages/layouts/application'

export default function Show({ settings }) {
  const { organization } = usePage().props.auth
  const { data, setData, patch, processing, transform } = useForm({
    custom_style_prompt: settings?.custom_style_prompt || '',
  })

  const handleSubmit = (e) => {
    e.preventDefault()

    transform(data => ({
      content_settings: data
    }))

    patch(styleGuideApi.update.path({ org_nano_id: organization.nano_id }))
  }

  return (
    <Layout>
      <PageHeader title="Style Prompt"/>
      <form onSubmit={handleSubmit} className="space-y-2">
        <div className="space-y-4">
          <textarea
            value={data.custom_style_prompt}
            onChange={(e) => setData('custom_style_prompt', e.target.value)}
            onInput={(e) => {
              e.currentTarget.style.height = 'auto'
              e.currentTarget.style.height = `${e.currentTarget.scrollHeight}px`
            }}
            placeholder="Add any additional instructions for how your content should sound. For instance: Avoid jargon. Avoid em dashes and emojis. Prefer concrete examples and concise punchy lines."
            className="w-[800px] rounded-md border border-muted bg-background px-4 py-3 text-sm placeholder:text-sm placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-border focus-visible:ring-offset-0 overflow-hidden resize-none"
            rows={4}
            disabled={processing}
          />
        </div>

        <div className="flex justify-start">
          <Button
            type="submit"
            size="sm"
            disabled={processing}
          >
            {processing ? 'Saving...' : 'Save Instructions'}
          </Button>
        </div>
      </form>
    </Layout>
  )
}
